import * as Sentry from '@sentry/vue';
import config, { isSentryEnabled } from '@/config';

if (isSentryEnabled()) {
  Sentry.init({
    dsn: config.sentry.dsn,
    environment: config.environment,
    release: process.env.VUE_APP_PACKAGE + '@' + process.env.VUE_APP_VERSION,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.vueIntegration({ attachProps: true }),
      Sentry.captureConsoleIntegration({ levels: ['error'] })
    ],
    debug: true,
  });
}
